import React, { useState } from 'react';

import { ellipse } from '../assets';
import { companies, circlePosition } from '../constants/companies';

const Experience = () => {
  const [descIndex, setDescIndex] = useState(null);

  return (
    <section className="pt-16 mb-[100px] md:mb-[160px]" id="experience">
      <div className="wrapper flex flex-col lg:flex-row justify-between gap-8 2xl:gap-0">
        <div
          className="max-w-full lg:max-w-[608px] min-h-fit lg:min-h-[678px] w-full py-16 px-10 lg:p-0
        bg-primaryBlack dark:bg-black3 flex flex-col justify-start lg:justify-center items-start lg:items-center rounded-2xl relative"
        >
          <div className="max-w-full lg:max-w-[392px]">
            <div className="section-title section-title2 pt-0 lg:pt-10">
              <h2
                className="relative text-white text-[32px] md:text-[40px] leading-[40px] md:leading-[60px]
               font-extrabold md:font-bold pb-5"
              >
                Working experience
              </h2>
            </div>
            <p className="text-white/80 text-[13px] leading-7">
              {descIndex === null
                ? 'With over 2 years of experience as a WordPress developer and 4 years as a front-end developer, I have a proven track record of delivering exceptional results.'
                : companies[descIndex].desc}
            </p>
            <div className="hidden md:flex relative h-[70px] items-center mt-9">
              <div className="w-[300px] bg-white/[23%] h-[1px]" />
              <div
                className={`absolute -left-[13px] w-[70px] h-[70px] bg-primaryBlack dark:bg-black3 rounded-full border border-white/[23%] 
              flex justify-center items-center transition-all duration-700
              ${descIndex !== null && circlePosition[descIndex]} `}
                style={
                  descIndex !== null
                    ? { borderColor: companies[descIndex].color }
                    : undefined
                }
              >
                <div
                  className="w-11 h-11 bg-white rounded-full transition-all duration-700"
                  style={
                    descIndex !== null
                      ? { background: companies[descIndex].color }
                      : undefined
                  }
                />
              </div>
            </div>
          </div>

          <div
            className="bg-lightBlue w-[10px] md:w-[14px] h-[10px] md:h-[14px] rounded-full absolute
            top-[30px] lg:top-[120px] right-[38px] lg:right-[110px]"
          />
          <img
            className="w-[14px] md:w-[36px] absolute left-[26px] xl:left-[97px] bottom-[14px] xl:bottom-8"
            src={ellipse}
            alt="ellipse"
          />
        </div>

        <div className="w-full max-w-full lg:max-w-[608px] flex flex-col justify-between gap-6 lg:gap-0">
          {companies.map((company, index) => (
            <div
              key={index}
              className={`group cursor-pointer flex items-center h-[122px] border border-gray2 dark:border-primaryGray rounded-[10px]
              py-8 px-9 gap-9 ${company.styles.divStyle} transition-all duration-300`}
              onClick={() => setDescIndex(index)}
              style={
                descIndex === index
                  ? {
                      borderColor: company.color,
                      boxShadow: '-25px 47px 66px rgba(0, 0, 0, 0.08)',
                    }
                  : undefined
              }
            >
              <img
                src={company.logo}
                alt={company.name}
                className={`max-w-[50px] brightness-0 dark:brightness-100 dark:grayscale dark:group-hover:grayscale-0 group-hover:brightness-100 
                transition-all duration-300  ${
                  descIndex === index
                    ? 'brightness-100 dark:grayscale-0'
                    : 'brightness-0 dark:grayscale'
                }`}
              />
              <div>
                <h3
                  className={`text-primaryBlack dark:text-gray3
                  ${company.styles.textStyle} transition-all duration-300 text-[20px] md:text-2xl font-bold leading-7 pb-2.5`}
                  style={
                    descIndex === index ? { color: company.color } : undefined
                  }
                >
                  {company.name}
                </h3>
                <p className="text-primaryGray text-xs font-semibold">
                  {company.position} - {company.duration}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
